export function isTouchDevice() {
    return (('ontouchstart' in window || navigator.maxTouchPoints) && window.innerWidth < 720);
}